/** Placeholder pages for the Accounting module — wired to CredoraComingSoon until implemented. */

export const ACCOUNTING_SECTION = "Accounting";

export const ACCOUNTING_PLACEHOLDERS = [
  {
    path: "accounting",
    menuTitle: "Overview",
    title: "Accounting Overview",
    description: "Dashboard for ledger health, open periods, pending approvals, and key accounting KPIs.",
    inMenu: true,
  },
  {
    path: "accounting/chart-of-accounts",
    menuTitle: "Chart of Accounts",
    title: "Chart of Accounts",
    description: "Configure account codes, types, and hierarchy for double-entry bookkeeping.",
    inMenu: true,
  },
  {
    path: "accounting/general-ledger",
    menuTitle: "General Ledger",
    title: "General Ledger",
    description: "Browse posted journal lines by account, branch, and financial period.",
    inMenu: true,
  },
  {
    path: "accounting/journal-entries",
    menuTitle: "Journal Entries",
    title: "Journal Entries",
    description: "Create, review, approve, and post manual and system-generated journal entries.",
    inMenu: true,
  },
  {
    path: "accounting/expenses",
    menuTitle: "Expenses",
    title: "Expenses",
    description: "Record, categorize, and track all operating expenses with attachments and approval workflow.",
    inMenu: true,
  },
  {
    path: "accounting/expense-categories",
    menuTitle: "Expense Categories",
    title: "Expense Categories",
    description: "Define expense types, GL mappings, and spending limits by department or branch.",
    inMenu: true,
  },
  {
    path: "accounting/vendors",
    menuTitle: "Vendors",
    title: "Vendors",
    description: "Maintain supplier profiles, payment terms, and linked payable accounts.",
    inMenu: true,
  },
  {
    path: "accounting/accounts-payable",
    menuTitle: "Accounts Payable",
    title: "Accounts Payable",
    description: "Manage bills, vendor invoices, payment schedules, and outstanding payables.",
    inMenu: true,
  },
  {
    path: "accounting/accounts-receivable",
    menuTitle: "Accounts Receivable",
    title: "Accounts Receivable",
    description: "Track non-loan receivables, fee accruals, and other amounts due to the institution.",
    inMenu: true,
  },
  {
    path: "accounting/bank-reconciliation",
    menuTitle: "Bank Reconciliation",
    title: "Bank Reconciliation",
    description: "Match bank statements to ledger cash accounts and clear unreconciled items.",
    inMenu: true,
  },
  {
    path: "accounting/petty-cash",
    menuTitle: "Petty Cash",
    title: "Petty Cash",
    description: "Manage branch petty cash floats, reimbursements, and custodian accountability.",
    inMenu: true,
  },
  {
    path: "accounting/fixed-assets",
    menuTitle: "Fixed Assets",
    title: "Fixed Assets Register",
    description: "Track asset acquisition, location, custodian, and book value over time.",
    inMenu: true,
  },
  {
    path: "accounting/depreciation",
    menuTitle: "Depreciation",
    title: "Depreciation",
    description: "Run depreciation schedules and post periodic depreciation journals.",
    inMenu: true,
  },
  {
    path: "accounting/payroll",
    menuTitle: "Payroll",
    title: "Payroll",
    description: "Salary accruals, statutory deductions, and payroll journal integration.",
    inMenu: true,
  },
  {
    path: "accounting/tax-vat",
    menuTitle: "Tax & VAT",
    title: "Tax & VAT",
    description: "Configure tax codes, VAT returns, and withholding summaries for compliance.",
    inMenu: true,
  },
  {
    path: "accounting/financial-periods",
    menuTitle: "Financial Periods",
    title: "Financial Periods",
    description: "Open and close accounting periods, year-end lock, and adjustment windows.",
    inMenu: true,
  },
  {
    path: "accounting/trial-balance",
    menuTitle: "Trial Balance",
    title: "Trial Balance",
    description: "Period-end trial balance with drill-down to account and journal detail.",
    inMenu: true,
  },
  {
    path: "accounting/balance-sheet",
    menuTitle: "Balance Sheet",
    title: "Balance Sheet",
    description: "Statement of financial position by branch and consolidated entity.",
    inMenu: true,
  },
  {
    path: "accounting/income-statement",
    menuTitle: "Income Statement",
    title: "Income Statement (P&L)",
    description: "Profit and loss by period with revenue, expense, and margin breakdown.",
    inMenu: true,
  },
  {
    path: "accounting/cash-flow",
    menuTitle: "Cash Flow",
    title: "Cash Flow Statement",
    description: "Operating, investing, and financing cash flows linked to the general ledger.",
    inMenu: true,
  },
  {
    path: "accounting/budget-vs-actual",
    menuTitle: "Budget vs Actual",
    title: "Budget vs Actual",
    description: "Compare budgets to actuals by account, branch, and cost center.",
    inMenu: true,
  },
  {
    path: "accounting/cost-centers",
    menuTitle: "Cost Centers",
    title: "Cost Centers",
    description: "Allocate expenses and revenue to branches, departments, and projects.",
    inMenu: true,
  },
  {
    path: "accounting/settings",
    menuTitle: "Accounting Settings",
    title: "Accounting Settings",
    description: "Fiscal calendar, default accounts, approval rules, and integration with treasury.",
    inMenu: true,
    manage: true,
  },
];
